export const MAX_SELECTABLE_COURSES = 1;
export const MAX_EXTRA_ATTACHMENTS = 11;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_FILE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'application/pdf',
];
export const FILE_VALIDATION_ERROR = `Carica un file valido di tipo PDF o JPG con dimensione massima di ${MAX_FILE_SIZE / 1024 / 1024}MB`


export const END_DATE_ENROLLS_TEXT = "24 ottobre";
export const START_DATE_PROVISION_TEXT = "25 ottobre";
export const END_DATE_PROVISION_TEXT = "25 ottobre";

export const CDC_FILIALE_LIST = [
  { codice: "FORIT", nome: "FORIT" },
  { codice: "101", nome:	"MOC ROMA" },
  { codice: "102", nome:	"VERONA PROF (HUB)" },
  { codice: "103", nome:	"BARI (HUB)" },
  { codice: "104", nome:	"TORINO ENG" },
  { codice: "106", nome:	"MILANO PROF" },
  { codice: "107", nome:	"BRESCIA PROF (HUB)" },
  { codice: "108", nome:	"PADOVA (HUB)" },
  { codice: "109", nome:	"MODENA ENG (HUB)" },
  { codice: "110", nome:	"FIRENZE ENG" },
  { codice: "111", nome:	"VICENZA (HUB)" },
  { codice: "112", nome:	"PESCARA (HUB)" },
  { codice: "113", nome:	"TREVISO (HUB)" },
  { codice: "114", nome:	"SALERNO (HUB)" },
  { codice: "115", nome:	"GENOVA (HUB)" },
  { codice: "116", nome:	"LECCE (HUB)" },
  { codice: "117", nome:	"VENEZIA MESTRE (HUB)" },
  { codice: "118", nome:	"BERGAMO (HUB)" },
  { codice: "120", nome:	"CUNEO (HUB)" },
  { codice: "121", nome:	"MOC MILANO" },
  { codice: "124", nome:	"NAPOLI (HUB)" },
  { codice: "125", nome:	"SIENA Curtatone" },
  { codice: "126", nome:	"ALESSANDRIA TORTONA (HUB)" },
  { codice: "127", nome:	"PRATO" },
  { codice: "129", nome:	"REGGIO EMILIA (HUB)" },
  { codice: "130", nome:	"BIELLA" },
  { codice: "131", nome:	"TRIESTE (HUB)" },
  { codice: "132", nome:	"ROMA ENG" },
  { codice: "135", nome:	"LECCO - ERBA (HUB)" },
  { codice: "136", nome:	"PERUGIA (HUB)" },
  { codice: "137", nome:	"SAN GIORGIO DI NOGARO" },
  { codice: "139", nome:	"MILANO ENG" },
  { codice: "140", nome:	"MOC FIRENZE" },
  { codice: "141", nome:	"ROMA PROF" },
  { codice: "142", nome:	"POGGIBONSI (HUB)" },
  { codice: "145", nome:	"MOC TORINO" },
  { codice: "146", nome:	"TRENTO (HUB)" },
  { codice: "147", nome:	"NOVARA (HUB)" },
  { codice: "149", nome:	"PARMA ENG (HUB)" },
  { codice: "152", nome:	"PALERMO (HUB)" },
  { codice: "153", nome:	"VARESE (HUB)" },
  { codice: "154", nome:	"LECCO - ERBA ENG (HUB)" },
  { codice: "155", nome:	"BOLZANO (HUB)" },
  { codice: "156", nome:	"ASTI" },
  { codice: "157", nome:	"THIENE San Vincenzo" },
  { codice: "158", nome:	"SAVONA" },
  { codice: "159", nome:	"PAVIA (HUB)" },
  { codice: "160", nome:	"PORDENONE (HUB)" },
  { codice: "163", nome:	"ASCOLI PICE. URBINO (HUB)" },
  { codice: "164", nome:	"PALAZZOLO S. OGLIO" },
  { codice: "165", nome:	"ALBA" },
  { codice: "167", nome:	"SARONNO" },
  { codice: "169", nome:	"ATESSA" },
  { codice: "171", nome:	"CASALE M.TO ENG (HUB)" },
  { codice: "172", nome:	"FROSINONE (HUB)" },
  { codice: "173", nome:	"RHO" },
  { codice: "174", nome:	"CASERTA (HUB)" },
  { codice: "175", nome:	"VERCELLI" },
  { codice: "177", nome:	"BASSANO D. GRAPPA" },
  { codice: "179", nome:	"FOGGIA" },
  { codice: "180", nome:	"CASALE M.TO (HUB)" },
  { codice: "181", nome:	"CREMA PROF (HUB)" },
  { codice: "182", nome:	"MONZA PROF (HUB)" },
  { codice: "183", nome:	"PIACENZA (HUB)" },
  { codice: "185", nome:	"CASTIGLIONE D. STIVIERe" },
  { codice: "186", nome:	"CASALE M.TO PROF (HUB)" },
  { codice: "187", nome:	"S. DONA DI PIAVE" },
  { codice: "188", nome:	"RAVENNA" },
  { codice: "189", nome:	"CONEGLIANO VEN." },
  { codice: "190", nome:	"CREMA (HUB)" },
  { codice: "192", nome:	"LODI PROF (HUB)" },
  { codice: "193", nome:	"MELFI ENG (HUB)" },
  { codice: "194", nome:	"BARI Dante GDO" },
  { codice: "195", nome:	"MAGENTA" },
  { codice: "196", nome:	"LEGNAGO" },
  { codice: "197", nome:	"SCHIO ENG" },
  { codice: "202", nome:	"LA SPEZIA" },
  { codice: "204", nome:	"RIMINI" },
  { codice: "205", nome:	"FERRARA (HUB)" },
  { codice: "206", nome:	"FERRARA ENG (HUB)" },
  { codice: "207", nome:	"CATANIA ENG (HUB)" },
  { codice: "208", nome:	"LODI (HUB)" },
  { codice: "211", nome:	"TERAMO (HUB)" },
  { codice: "212", nome:	"LUCCA" },
  { codice: "214", nome:	"PINEROLO (HUB)" },
  { codice: "215", nome:	"AOSTA" },
  { codice: "216", nome:	"ROVERETO ENG" },
  { codice: "217", nome:	"POMEZIA (HUB)" },
  { codice: "219", nome:	"MERATE" },
  { codice: "220", nome:	"CANTU" },
  { codice: "222", nome:	"CASTELFRANCO VENETO" },
  { codice: "224", nome:	"TREZZANO PROF (HUB)" },
  { codice: "226", nome:	"TERNI (HUB)" },
  { codice: "227", nome:	"MONFALCONE ENG (HUB)" },
  { codice: "230", nome:	"ALBINO" },
  { codice: "232", nome:	"PESARO (HUB)" },
  { codice: "234", nome:	"BOLLATE (HUB)" },
  { codice: "235", nome:	"TARANTO" },
  { codice: "236", nome:	"TORINO PROF" },
  { codice: "237", nome:	"BORGOMANERO (HUB)" },
  { codice: "239", nome:	"BRESCIA ENG (HUB)" },
  { codice: "240", nome:	"AGRATE BRIANZA (HUB)" },
  { codice: "241", nome:	"AGRATE BRIANZA ENG (HUB)" },
  { codice: "243", nome:	"SUZZARA ENG" },
  { codice: "245", nome:	"RIVAROLO" },
  { codice: "247", nome:	"LEGNANO" },
  { codice: "248", nome:	"GALLARATE PROF (HUB)" },
  { codice: "250", nome:	"VENARIA REALE" },
  { codice: "251", nome:	"GRUGLIASCO" },
  { codice: "253", nome:	"BORGOMANERO ENG (HUB)" },
  { codice: "254", nome:	"SAN BONIFACIO" },
  { codice: "255", nome:	"CHIERI" },
  { codice: "257", nome:	"BORGOMANERO PROF (HUB)" },
  { codice: "259", nome:	"TREZZANO (HUB)" },
  { codice: "260", nome:	"ODERZO" },
  { codice: "262", nome:	"CAMPOSAMPIERO" },
  { codice: "263", nome:	"CIVITANOVA MARCHE" },
  { codice: "264", nome:	"SAN VITO AL TAGLIAMENTO" },
  { codice: "265", nome:	"MIRANDOLA" },
  { codice: "266", nome:	"IMOLA" },
  { codice: "268", nome:	"CASSINO" },
  { codice: "273", nome:	"LECCO - ERBA PROF (HUB)" },
  { codice: "274", nome:	"CESANO MADERNO" },
  { codice: "277", nome:	"BERGAMO ENG (HUB)" },
  { codice: "281", nome:	"FERRARA PROF (HUB)" },
  { codice: "282", nome:	"MILANO Filzi 2" },
  { codice: "284", nome:	"MONFALCONE (HUB)" },
  { codice: "286", nome:	"MIRANO ENG" },
  { codice: "287", nome:	"MESTRINO" },
  { codice: "288", nome:	"VIGEVANO" },
  { codice: "289", nome:	"MONTEBELLUNA" },
  { codice: "291", nome:	"CIRIE'" },
  { codice: "293", nome:	"FABRIANO" },
  { codice: "294", nome:	"GEMONA" },
  { codice: "295", nome:	"TREZZO SULL'ADDA" },
  { codice: "296", nome:	"MONSELICE (HUB)" },
  { codice: "297", nome:	"SAREZZO" },
  { codice: "298", nome:	"PINEROLO ENG (HUB)" },
  { codice: "300", nome:	"MONDOVI" },
  { codice: "302", nome:	"FIRENZE PROF" },
  { codice: "303", nome:	"AVELLINO (HUB)" },
  { codice: "308", nome:	"MODENA PROF (HUB)" },
  { codice: "310", nome:	"TO Reg.Margh.CC" },
  { codice: "312", nome:	"CARPI" },
  { codice: "314", nome:	"MELFI (HUB)" },
  { codice: "315", nome:	"PARMA (HUB)" },
  { codice: "317", nome:	"MONZA (HUB)" },
  { codice: "319", nome:	"VICENZA PROF (HUB)" },
  { codice: "322", nome:	"CERNUSCO SUL NAVIGLIO" },
  { codice: "323", nome:	"TREZZANO ENG (HUB)" },
  { codice: "324", nome:	"PESCHIERA BORR. (HUB)" },
  { codice: "325", nome:	"VARESE PROF (HUB)" },
  { codice: "327", nome:	"FAENZA" },
  { codice: "330", nome:	"COMO" },
  { codice: "332", nome:	"ASCOLI PICENO UR PROF HUB" },
  { codice: "335", nome:	"TERNI ENG (HUB)" },
  { codice: "339", nome:	"NERVIANO" },
  { codice: "340", nome:	"REGGIO EMILIA ENG (HUB)" },
  { codice: "341", nome:	"BOLLATE PROF (HUB)" },
  { codice: "342", nome:	"PADOVA PROF (HUB)" },
  { codice: "343", nome:	"VENEZIA MESTRE PROF (HUB)" },
  { codice: "344", nome:	"FROSINONE ENG (HUB)" },
  { codice: "346", nome:	"COLOGNO MONZESE" },
  { codice: "349", nome:	"VERONA (HUB)" },
  { codice: "350", nome:	"MOC BOLOGNA" },
  { codice: "354", nome:	"ARZIGNANO" },
  { codice: "355", nome:	"SAN PELLEGRINO TERME" },
  { codice: "356", nome:	"FROSINONE PROF (HUB)" },
  { codice: "357", nome:	"SALUZZO (HUB)" },
  { codice: "358", nome:	"SPILIMBERGO" },
  { codice: "359", nome:	"BESANA BRIANZA" },
  { codice: "360", nome:	"GALLARATE ENG (HUB)" },
  { codice: "361", nome:	"LODI ENG (HUB)" },
  { codice: "362", nome:	"OSPITALETTO" },
  { codice: "363", nome:	"TREVISO PROF (HUB)" },
  { codice: "369", nome:	"VIMERCATE Marc2" },
  { codice: "370", nome:	"PINEROLO PROF (HUB)" },
  { codice: "374", nome:	"FERMO" },
  { codice: "375", nome:	"PISTOIA" },
  { codice: "377", nome:	"SALUZZO ENG (HUB)" },
  { codice: "378", nome:	"AREZZO PROF (HUB)" },
  { codice: "379", nome:	"VALTELLINA (HUB)" },
  { codice: "381", nome:	"CESENA" },
  { codice: "383", nome:	"BOLOGNA ENG" },
  { codice: "384", nome:	"FIORENZUOLA" },
  { codice: "387", nome:	"GAVARDO ENG" },
  { codice: "389", nome:	"VALTELLINA ENG (HUB)" },
  { codice: "391", nome:	"MONSELICE PROF (HUB)" },
  { codice: "392", nome:	"MONSELICE ENG (HUB)" },
  { codice: "395", nome:	"ALESSANDRIA TORT PROF HUB" },
  { codice: "397", nome:	"AGRATE BRIANZA PROF (HUB)" },
  { codice: "400", nome:	"BRINDISI" },
  { codice: "401", nome:	"VILLAFRANCA" },
  { codice: "403", nome:	"BERGAMO PROF (HUB)" },
  { codice: "404", nome:	"UDINE (HUB)" },
  { codice: "405", nome:	"NAPOLI PROF (HUB)" },
  { codice: "406", nome:	"BRESCIA (HUB)" },
  { codice: "407", nome:	"VERONA ENG (HUB)" },
  { codice: "408", nome:	"BUSSOLENGO" },
  { codice: "409", nome:	"SALERNO ENG (HUB)" },
  { codice: "410", nome:	"LUGO DI RAVENNA" },
  { codice: "411", nome:	"MONTECCHIO" },
  { codice: "412", nome:	"SIRACUSA ENG (HUB)" },
  { codice: "413", nome:	"CATANIA (HUB)" },
  { codice: "414", nome:	"CASERTA ENG (HUB)" },
  { codice: "416", nome:	"CALUSCO D'ADDA" },
  { codice: "420", nome:	"PADOVA ENG (HUB)" },
  { codice: "422", nome:	"AVEZZANO" },
  { codice: "424", nome:	"NOVARA PROF (HUB)" },
  { codice: "425", nome:	"MANTOVA PROF (HUB)" },
  { codice: "426", nome:	"BARI ENG (HUB)" },
  { codice: "427", nome:	"TRENTO ENG (HUB)" },
  { codice: "430", nome:	"ANCONA PROF (HUB)" },
  { codice: "431", nome:	"VICENZA ENG (HUB)" },
  { codice: "437", nome:	"SAN SALVO" },
  { codice: "438", nome:	"LIVORNO (HUB)" },
  { codice: "440", nome:	"PORDENONE PROF (HUB)" },
  { codice: "441", nome:	"NOVENTA VICENTINA" },
  { codice: "442", nome:	"NOVARA ENG (HUB)" },
  { codice: "443", nome:	"BESOZZO" },
  { codice: "445", nome:	"ARCO" },
  { codice: "447", nome:	"PESCARA PROF (HUB)" },
  { codice: "450", nome:	"IMPERIA" },
  { codice: "452", nome:	"POGGIBONSI ENG (HUB)" },
  { codice: "453", nome:	"BIBBIENA" },
  { codice: "455", nome:	"GALLARATE (HUB)" },
  { codice: "457", nome:	"PIACENZA ENG (HUB)" },
  { codice: "462", nome:	"PORDENONE ENG (HUB)" },
  { codice: "464", nome:	"LOVERE" },
  { codice: "466", nome:	"NOGARA" },
  { codice: "474", nome:	"PESCARA ENG (HUB)" },
  { codice: "479", nome:	"CANELLI" },
  { codice: "482", nome:	"PIACENZA PROF (HUB)" },
  { codice: "483", nome:	"MANTOVA (HUB)" },
  { codice: "485", nome:	"CAGLIARI PROF (HUB)" },
  { codice: "486", nome:	"CARMAGNOLA" },
  { codice: "491", nome:	"BARI PROF (HUB)" },
  { codice: "492", nome:	"LATINA ENG (HUB)" },
  { codice: "493", nome:	"BOLOGNA PROF" },
  { codice: "496", nome:	"GROSSETO" },
  { codice: "497", nome:	"POMEZIA ENG (HUB)" },
  { codice: "499", nome:	"UDINE PROF (HUB)" },
  { codice: "511", nome:	"MONTECCHIO MAGGIORE" },
  { codice: "512", nome:	"LATINA (HUB)" },
  { codice: "514", nome:	"ORZINUOVI" },
  { codice: "515", nome:	"STRADELLA " },
  { codice: "517", nome:	"TRAPANI" },
  { codice: "518", nome:	"MONTICHIARI City" },
  { codice: "525", nome:	"ON SITE ADRIATICA" },
  { codice: "526", nome:	"ON SITE EMILIA" },
  { codice: "528", nome:	"CHIAVARI" },
  { codice: "529", nome:	"ON SITE NORD OVEST" },
  { codice: "530", nome:	"ON SITE VIC. PAD. E ROV." },
  { codice: "538", nome:	"CAGLIARI ENG (HUB)" },
  { codice: "539", nome:	"BELLUNO" },
  { codice: "540", nome:	"OS AZIMUT" },
  { codice: "543", nome:	"ON SITE CENTRO" },
  { codice: "545", nome:	"SIRACUSA (HUB)" },
  { codice: "546", nome:	"CAGLIARI (HUB)" },
  { codice: "547", nome:	"LECCE ENG (HUB)" },
  { codice: "548", nome:	"CUNEO ENG (HUB)" },
  { codice: "549", nome:	"SETTIMO T.SE (HUB)" },
  { codice: "550", nome:	"ON SITE LOMBARDIA CENTRO" },
  { codice: "551", nome:	"ON SITE TIRRENICA" },
  { codice: "553", nome:	"PERUGIA PROF (HUB)" },
  { codice: "554", nome:	"L'AQUILA" },
  { codice: "555", nome:	"UDINE ENG (HUB)" },
  { codice: "557", nome:	"PESCHIERA BOR PROF (HUB)" },
  { codice: "558", nome:	"SETTIMO T.SE ENG (HUB)" },
  { codice: "560", nome:	"SETTIMO T.SE PROF (HUB)" },
  { codice: "561", nome:	"PARMA PROF (HUB)" },
  { codice: "562", nome:	"REGGIO EMILIA PROF (HUB)" },
  { codice: "563", nome:	"FORLI" },
  { codice: "564", nome:	"MODENA (HUB)" },
  { codice: "565", nome:	"PERUGIA ENG (HUB)" },
  { codice: "566", nome:	"LIVORNO PROF (HUB)" },
  { codice: "567", nome:	"AREZZO (HUB)" },
  { codice: "570", nome:	"CUNEO PROF (HUB)" },
  { codice: "573", nome:	"ANCONA (HUB)" },
  { codice: "574", nome:	"ON SITE LOMB ORIENTALE" },
  { codice: "576", nome:	"ON SITE TRIV OCCIDENTALE" },
  { codice: "581", nome:	"COLLECCHIO" },
  { codice: "584", nome:	"CAMPOBASSO" },
  { codice: "585", nome:	"VALTELLINA PROF (HUB)" },
  { codice: "587", nome:	"AVELLINO ENG (HUB)" },
  { codice: "588", nome:	"ON SITE TRIV ORIENTALE" },
  { codice: "589", nome:	"TREVIGLIO" },
  { codice: "590", nome:	"RIVOLI" },
  { codice: "591", nome:	"BORGO SAN LORENZO Trieste" },
  { codice: "597", nome:	"TRENTO PROF (HUB)" },
  { codice: "602", nome:	"CREMONA" },
  { codice: "603", nome:	"BOLZANO ENG (HUB)" },
  { codice: "606", nome:	"IVREA" },
  { codice: "607", nome:	"AREZZO ENG (HUB)" },
  { codice: "609", nome:	"NAPOLI ENG (HUB)" },
  { codice: "610", nome:	"VARESE ENG (HUB)" },
  { codice: "611", nome:	"PAVIA ENG (HUB)" },
  { codice: "614", nome:	"CATANIA PROF (HUB)" },
  { codice: "617", nome:	"GENOVA PROF (HUB)" },
  { codice: "624", nome:	"PESARO ENG (HUB)" },
  { codice: "628", nome:	"TERAMO ENG (HUB)" },
  { codice: "629", nome:	"TREVISO ENG (HUB)" },
  { codice: "630", nome:	"LIVORNO ENG (HUB)" },
  { codice: "633", nome:	"SALUZZO PROF (HUB)" },
  { codice: "638", nome:	"PALERMO PROF (HUB)" },
];


